<template>
    <div class="main">
        <div class="inner" :style="{'width': `${perc}%`, 'background': color}" />
    </div>
</template>

<script>
export default {
    name: 'scroll-indicator',
    props: {
        color: {
            type: String,
            default: 'black'
        }
    },
    created() {
    
    },
    mounted() {
     window.addEventListener('scroll', e => {
            let scrollPos = window.scrollY
            let winHeight = window.innerHeight
            let docHeight = document.documentElement.scrollHeight // instead document.body.clientHeight
            this.perc = 100 * scrollPos / (docHeight - winHeight)
        })
    },
    data() {
      return {
        perc: 0
      }
    },
  }
</script>

<style scoped>
    .main {
        width: 100%;
        height: 100%;
    }
    .inner {
        height: 100%;
        background-color: #3d3d3d;
    }
</style>


// WEBPACK FOOTER //
// ScrollIndicator.vue?d7520746